var _path, _path2, _circle, _circle2, _path3, _path4, _line, _line2, _line3, _line4, _rect, _rect2, _rect3, _rect4, _rect5, _circle3, _circle4, _circle5, _circle6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoLongBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0 30 C 70 30, 150 35, 197 50 L 197 150 C 150 165, 70 170, 0 170 Z",
    strokeWidth: 3,
    fill: "#aaa",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 2 40 L 20 40 L 30 80 L 30 120 L 20 160 L 2 160",
    strokeWidth: 2,
    stroke: "black",
    fill: "transparent"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    cx: 2,
    cy: 70,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 20,
    cx: 2,
    cy: 130,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 35 45 L 60 70 L 85 70 L 85 130 L 60 130 L 35 155 Z",
    strokeWidth: 2,
    stroke: "black",
    fill: "transparent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 100 45 L 190 60 L 190 140 L 100 155 Z",
    strokeWidth: 5,
    stroke: "white",
    fill: "transparent"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: 50,
    x2: 135,
    y2: 150,
    strokeWidth: 10,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 45,
    x2: 135,
    y2: 100,
    strokeWidth: 5,
    stroke: "white"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 155,
    x2: 135,
    y2: 100,
    strokeWidth: 5,
    stroke: "white"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 100,
    x2: 135,
    y2: 100,
    strokeWidth: 5,
    stroke: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 97.5,
    width: 10,
    height: 5,
    strokeWidth: 0,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 97.5,
    width: 10,
    height: 5,
    strokeWidth: 0,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 97.5,
    width: 10,
    height: 5,
    strokeWidth: 0,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 70,
    width: 5,
    height: 10,
    strokeWidth: 0,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 162.5,
    y: 120,
    width: 5,
    height: 10,
    strokeWidth: 0,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 55,
    cy: 48,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 79,
    cy: 54,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 55,
    cy: 152,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    cx: 79,
    cy: 146,
    fill: "transparent",
    stroke: "black",
    strokeWidth: 3
  })), "\n  Sorry, your browser does not support inline SVG.\n");
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoLongBack);
export default __webpack_public_path__ + "static/media/TwoLongBack.b6c62d1a7d058b3ffdc067951af535c2.svg";
export { ForwardRef as ReactComponent };